export default "__VITE_ASSET__5l7rAhd2__"